export default __webpack_public_path__ + "locales/hy-AM/About.json?hash=e1fe60b0e067f639a964ac83ad4a2673";